
import './App.css';
import UpArrow from './Components/UpArrow';
import MainRoutes from './Routes/MainRoutes';

function App() {
  return (
    <div className="App">
      <MainRoutes />
      <UpArrow />
    </div>
  );
}

export default App;
